export const UseDesk = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1304_8087)">
        <rect
          x="16"
          y="8"
          width="48"
          height="48"
          rx="12"
          fill="white"
          fillOpacity="0.5"
        />
        <rect
          x="16.5"
          y="8.5"
          width="47"
          height="47"
          rx="11.5"
          stroke="white"
        />
        <mask
          id="mask0_1304_8087"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="27"
          y="19"
          width="26"
          height="26"
        >
          <path
            d="M40.4265 19.0068C32.9051 18.7675 26.7674 24.9156 27.0068 32.4265C27.2252 39.23 32.7698 44.7852 39.5735 44.9932C47.0949 45.2325 53.2326 39.0844 52.9932 31.5735C52.7748 24.77 47.2302 19.2252 40.4265 19.0068ZM40 38.5018C36.411 38.5018 33.4983 35.589 33.4983 32C33.4983 28.411 36.411 25.4982 40 25.4982C43.589 25.4982 46.5018 28.411 46.5018 32C46.5018 35.589 43.589 38.5018 40 38.5018Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1304_8087)">
          <mask
            id="mask1_1304_8087"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="-129"
            y="19"
            width="183"
            height="42"
          >
            <path
              d="M53.0011 19.0001H-128.999V60.6001H53.0011V19.0001Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1304_8087)">
            <mask
              id="mask2_1304_8087"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="25"
              y="19"
              width="28"
              height="28"
            >
              <path
                d="M52.9991 18.9999H25.9863V46.0399H52.9991V18.9999Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_1304_8087)">
              <mask
                id="mask3_1304_8087"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="25"
                y="18"
                width="28"
                height="29"
              >
                <path
                  d="M52.9981 18.9999H25.9854V46.0399H52.9981V18.9999Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask3_1304_8087)">
                <path
                  d="M58.4011 13.7999H21.9336V50.1999H58.4011V13.7999Z"
                  fill="#757576"
                />
              </g>
            </g>
            <mask
              id="mask4_1304_8087"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="25"
              y="19"
              width="28"
              height="28"
            >
              <path
                d="M52.9991 18.9999H25.9863V46.0399H52.9991V18.9999Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_1304_8087)">
              <mask
                id="mask5_1304_8087"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="26"
                y="19"
                width="27"
                height="26"
              >
                <path
                  d="M52.9989 21.5999L50.3992 18.9999L39.999 29.4L29.5992 18.9999L26.999 21.5999L37.3988 31.9999L26.999 42.3999L29.5992 44.9999L39.999 34.6L50.3992 44.9999L52.9989 42.3999L42.5991 31.9999L52.9989 21.5999Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask5_1304_8087)">
                <mask
                  id="mask6_1304_8087"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="25"
                  y="19"
                  width="28"
                  height="28"
                >
                  <path
                    d="M52.9976 19H25.9849V46.04H52.9976V19Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask6_1304_8087)">
                  <path
                    d="M58.4006 13.8H21.9326V50.2H58.4006V13.8Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_1304_8087"
          x="0"
          y="0"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1304_8087"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1304_8087"
            result="effect2_dropShadow_1304_8087"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1304_8087"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
